/* @ngInject */
const saleRequest = (
  $q,
  saleResource,
  valueHandler,
  saleFormat,
  errorHandler,
  labels
) => {
  const self = {}

  self.getBySearch = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$$sale.getBySearch'
      const data = saleFormat.server(_data)
      saleResource.post({ action: 'search', }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            sales: res.data,
            message: labels.sale.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.sale.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  // self.getById = (_saleId) => {
  //   return $q(async (resolve, reject) => {
  //     try {
  //       const response = await self.getBySearch({ id: _saleId, })
  //       const sales = response.sales
  //       if (sales.length === 1) {
  //         resolve(sales[0])
  //       } else {
  //         reject(labels.sale.log.search.noResultWithId)
  //       }
  //     } catch (error) {
  //       reject(error)
  //     }
  //   })
  // }

  self.getById = (_id) => {
    return $q(async (resolve, reject) => {
      const functionName = 'getById'
      try {
        saleResource.get({
          action: _id,
        }, (res) => {
          if (res && res.success) {
            resolve(res.data)
          } else if (valueHandler.isString(res)) {
            reject(res)
          } else {
            errorHandler.message(res, functionName, data)
            reject(labels.sale.log.search.noResultWithId)
          }
        }, (error) => {
          errorHandler.status(error, functionName)
          reject(labels.log.failure)
        })
      } catch (error) {
        reject(error)
      }
    })
  }

  self.getAll = () => {
    return $q((resolve, reject) => {
      const functionName = '$$sale.getAll'
      saleResource.get({}, {}, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            sales: res.data,
            message: labels.sale.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.sale.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.save = (_sale, _wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$$sale.save'
      const data = {
        sale: saleFormat.server(_sale),
        wagonIds: _wagonIds,
      }
      saleResource.save({}, data, (res) => {
        if (res.success) {
          const response = {
            id: res.data.id,
            message: res.message,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.sale.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, data)
            reject(labels.sale.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_sale, _wagonIds) => {
    return $q((resolve, reject) => {
      const functionName = '$$sale.update'
      const data = {
        sale: saleFormat.server(_sale),
        wagonIds: _wagonIds,
      }
      saleResource.update({ action: _sale.id }, data, (res) => {
        if (res.success) {
          const response = {
            message: res.message,
            sale: res.data,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.sale.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.updateAllAxletrees = (_saleId, _weight) => {
    return $q((resolve, reject) => {
      const functionName = '$$sale.updateAllAxletrees'
      const data = {
        saleId: _saleId,
        weight: _weight,
      }

      saleResource.post({ 'allAxletrees': true, }, data, (res) => {
        if (res.success) {
          const response = {
            message: res.message,
            sale: res.sale,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.sale.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$$sale.delete'
      saleResource.delete({ action: _id, }, (res) => {
        if (res.success) {
          resolve(res.message)
        } else {
          errorHandler.message(res, functionName, _id)
          reject(labels.sale.log.delete.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}
export default saleRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/scrapping/sale/services/request.service.js